<template>
    <span v-if="specifications && specifications.length > 0">{{ beginTimes[beginTimeAsNumber] }} - {{ endTimes[endTimeAsNumber] }}</span>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {TemplateSpecification} from '@cquential/api';
    import Dates from '@cquential/date-utils';

    @Component
    export default class KeyboardDeploymentAutocompleteSpecification extends Vue {
        @Prop() public specifications?: TemplateSpecification[];

        public get beginTimes(): Record<number, string> {
            return this.specifications ? this.createTimeMap(this.specifications, 'begin') : {};
        }

        public get endTimes(): Record<number, string> {
            return this.specifications ? this.createTimeMap(this.specifications, 'end') : {};
        }

        public get beginTimeAsNumber(): number {
            return Math.min(...Object.keys(this.beginTimes).map(Number));
        }

        public get endTimeAsNumber(): number {
            return Math.max(...Object.keys(this.endTimes).map(Number));
        }

        private createTimeMap(specifications: TemplateSpecification[], prop: 'begin' | 'end'): Record<number, string> {
            const result: Record<number, string> = {};
            for (const specification of specifications) {
                result[Dates.Time.parse(specification[prop])] = specification[prop];
            }

            return result;
        }
    }
</script>

<style lang="scss" scoped>
    span {
        padding-left: 0.75rem;
        font-size: 10px;
        color: var(--shift-dropdown-times-text-color);
    }
</style>
